import axios from "axios";

const OtpService = {
    async sendOTP(phone, email) {
        try {
            const isSriLankanPhone = /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/.test(phone);

            const endpoint = isSriLankanPhone
                ? `${process.env.REACT_APP_BACKEND_URL}user/send-otp/srilanka`
                : `${process.env.REACT_APP_BACKEND_URL}user/send-otp/international`;

            const data = isSriLankanPhone ? { phoneNumber: phone, email } : { email };

            const response = await axios.post(endpoint, data);
            return response?.data?.data;
        } catch (error) {
            console.error("Error sending OTP:", error);
            throw new Error("Failed to send OTP. Please try again.");
        }
    },

    async verifyOTP(phone, email, otp) {
        try {
            const isSriLankanPhone = /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/.test(phone);
            const endpoint = isSriLankanPhone
                ? `${process.env.REACT_APP_BACKEND_URL}user/verify-otp/srilanka`
                : `${process.env.REACT_APP_BACKEND_URL}user/verify-otp/international`;
            const data = isSriLankanPhone ? { phoneNumber: phone, email, otp } : { email, otp };
            const response = await axios.post(endpoint, data);
            return response?.data?.data;
        } catch (error) {
            console.error("Error verifying OTP:", error);
            throw new Error("Failed to verify OTP. Please try again.");
        }
    },

    // async verifyOTPSignIn(phone, email, otp) {
    //     try {
    //         const isSriLankanPhone = /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/.test(phone);
    //         const endpoint = isSriLankanPhone
    //             ? `${process.env.REACT_APP_BACKEND_URL}user/verify-otp-sign-in/srilanka`
    //             : `${process.env.REACT_APP_BACKEND_URL}user/verify-otp-sign-in/international`;
    //         const data = isSriLankanPhone ? { phoneNumber: phone, email, otp } : { email, otp };
    //         const response = await axios.post(endpoint, data);
    //         return response?.data?.data;
    //     } catch (error) {
    //         console.error("Error verifying OTP:", error);
    //         throw new Error("Failed to verify OTP. Please try again.");
    //     }
    // }
};

export default OtpService;
